/**
 *
 * @module graphQlQuery
 *
 */

import Services from './../services/entry';

/**
 *
 * @class GraphQlQuery
 * @extends {SDK.Services.Content.GraphQlQuery}
 * @desc Represents a GraphQL query.
 *
 */
export default class GraphQlQuery extends Services.Content.GraphQlQuery {}



// WEBPACK FOOTER //
// ./src/content/graphQlQuery.js